import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, report, nextReport }) =>
    present(
      repository
        .updateProjectReport(project, report, nextReport)
        .then((savedReport) => ({ project, report: savedReport }))
        .catch(() =>
          Promise.reject({
            project,
            report,
            nextReport,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
